import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../../components/PageHeader';
import { PageContent, PageLayout } from '../../../layout';
import { InvoiceManagementInvoiceTable } from '../../../modules/invoice-management/InvoiceManagementInvoiceTable';

export const InvoiceManagementInvoicesPage = () => {
  const { t } = useTranslation();
  return (
    <PageLayout>
      <PageHeader
        title={t('invoices.overview')}
        backRouteTo={null}
        action={
          <Button
            size={'large'}
            component={Link}
            to={'/invoice-management/invoices/create'}
            startIcon={<Add />}
            variant={'contained'}
          >
            {t('newInvoice')}
          </Button>
        }
      />
      <PageContent sx={{ alignItems: 'flex-start', justifyContent: 'flex-start' }}>
        <InvoiceManagementInvoiceTable />
      </PageContent>
    </PageLayout>
  );
};
